import { createAction } from "@reduxjs/toolkit";

export const apiCallError = createAction("api/callError");
